var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.854 8.35403L6.85403 13.354C6.80757 13.4005 6.75242 13.4373 6.69173 13.4625C6.63103 13.4876 6.56598 13.5006 6.50028 13.5006C6.43458 13.5006 6.36953 13.4876 6.30883 13.4625C6.24813 13.4373 6.19298 13.4005 6.14653 13.354C6.10007 13.3076 6.06322 13.2524 6.03808 13.1917C6.01294 13.131 6 13.066 6 13.0003C6 12.9346 6.01294 12.8695 6.03808 12.8088C6.06322 12.7481 6.10007 12.693 6.14653 12.6465L10.7934 8.00028L6.14653 3.35403C6.05271 3.26021 6 3.13296 6 3.00028C6 2.8676 6.05271 2.74035 6.14653 2.64653C6.24035 2.55271 6.3676 2.5 6.50028 2.5C6.63296 2.5 6.76021 2.55271 6.85403 2.64653L11.854 7.64653C11.9005 7.69296 11.9374 7.74811 11.9626 7.80881C11.9877 7.86951 12.0007 7.93457 12.0007 8.00028C12.0007 8.06599 11.9877 8.13105 11.9626 8.19175C11.9374 8.25245 11.9005 8.30759 11.854 8.35403Z",
    fill: "#67667A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.099a34514c71996c932e0106e9fdc324.svg";
export { ForwardRef as ReactComponent };